import React, { useState } from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { MultiSelect } from "@/components/MultiSelect/MultiSelect";

interface TagsInputProps {
  value: string[];
  onChange: (value: string[]) => void;
}

/**
 * Free-entry tag editor. New tags are typed and added; once present, tags can
 * be toggled / removed through the shared `MultiSelect` (whose option list is
 * the current set of tags).
 */
export function TagsInput({ value, onChange }: TagsInputProps) {
  const [newTag, setNewTag] = useState("");

  const handleAddTag = () => {
    const trimmed = newTag.trim();
    if (trimmed === "" || value.includes(trimmed)) {
      setNewTag("");
      return;
    }
    onChange([...value, trimmed]);
    setNewTag("");
  };

  const options = value.map((tag) => ({ label: tag, value: tag }));

  return (
    <div className="space-y-2">
      <div className="flex items-center gap-2">
        <Input
          aria-label="New tag"
          onChange={(e) => setNewTag(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              handleAddTag();
            }
          }}
          placeholder="Add a tag..."
          value={newTag}
        />
        <Button
          onClick={handleAddTag}
          size="sm"
          type="button"
          variant="outline"
        >
          Add
        </Button>
      </div>

      {value.length > 0 && (
        <MultiSelect
          onChange={onChange}
          options={options}
          placeholder="No tags"
          value={value}
        />
      )}
    </div>
  );
}
